import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Box, IconButton } from "@mui/material";
const ZoomComponent = ({ handleZoom }) => {
  return (
    <Box
      sx={{
        background: "#ffffff",
        display: "flex",
        flexDirection: "column",
        borderRadius: "5px",
      }}
      boxShadow={3}
    >
      <IconButton
        sx={{ background: "#ffffff", borderRadius: 0, padding: "3px" }}
      >
        <AddIcon
          onClick={() => {
            handleZoom("in");
          }}
          style={{ color: "#262B3E", fontSize: "1.6rem" }}
        />
      </IconButton>
      <IconButton sx={{ borderRadius: 0, cursor: "pointer", padding: "3px" }}>
        <RemoveIcon
          onClick={() => {
            handleZoom("out");
          }}
          style={{ color: "#262B3E", fontSize: "1.6rem" }}
        />
      </IconButton>
    </Box>
  );
};

export default ZoomComponent;
